import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconHistorySolid({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 16.8 16.8" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
        d="M16.8 8.4C16.8 13.039 13.039 16.8 8.4 16.8C3.76102 16.8 0 13.039 0 8.4C0 3.76102 3.76102 0 8.4 0C13.039 0 16.8 3.76102 16.8 8.4ZM7.49965 4.2332C7.49983 3.73632 7.90307 3.33383 8.4 3.33383C8.89692 3.33383 9.30017 3.73632 9.30035 4.2332V7.49965H12.5668C13.0637 7.49983 13.4662 7.90307 13.4662 8.4C13.4662 8.89692 13.0637 9.30017 12.5668 9.30035H8.4C7.90297 9.30035 7.49965 8.89703 7.49965 8.4V4.2332Z"
      />
    </Svg>
  )
}
